import React, { Component } from 'react';
import Header from '../../components/Header/Header';
import NoLocationPlaceHolder from '../../components/NoLocationPlaceholder/NoLocationPlaceholder';

class Dashboard extends Component {
  constructor(props){
    super(props);
    if(!this.props.client){
      this.props.updateClient();
    }
  }
  
  get menuSource(){
    let baseUrl = "https://verify.honeycomb.ai?id=";
    if(this.props.client && this.props.client.locations){
      baseUrl += this.props.client.locations[this.props.activeLocation]["code"]
      return baseUrl;
    }
    return null;
  }

  /**
   * Renders placeholder component if user has not added a location yet
   */
  get noLocation(){
    return(
      <div>
        {this.header}
        <div className="pageContainer">
          <NoLocationPlaceHolder/>
        </div>
      </div>
    )
  }

  get header(){
    return(
      <Header
        pageName="MENU"
      />
    )
  }

  render() {
    if (!this.props.client || !this.props.client.locations || 
        this.props.client.locations.length == 0)
      return (this.header, this.noLocation);

    return (
      <div className="animated fadeIn">
        {this.header}
        <div className="embed-responsive embed-responsive">
          <iframe 
            className="embed-responsive-item" 
            src= {this.menuSource}
            allowFullScreen
          >
          </iframe>
        </div>
      </div>
    )
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.js